export const animateMain = {
  initial: { x: "100vw", opacity: 0 },
  animate: { x: 0, opacity: 1 },
  exit: { x: "-130vw", opacity: 0 },
  duration: { duration: 0.4 },
};
